import { GET } from "./";
export const typeAccountPermit = {
  get: () => GET(`/api/typeAccountPermit`),
};
